import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import * as fromGraphQl from './graphql';
import { ApolloService } from '../apollo.service';
import { Label } from '../../entities/label/label';

/**
 * The label service.
 *
 * Migrated 1:1 from @nexato/nx-core-module (label/services/label.service.ts, #683).
 */
@Injectable()
export class LabelService {
  constructor(
    private apolloService: ApolloService,
  ) {
  }

  public getLabels(filter?: fromGraphQl.LabelFilter): Observable<Label[]> {
    const queryFilter = filter || {};
    return this.apolloService.query<fromGraphQl.GetLabelsResponse>(fromGraphQl.GET_LABELS_QUERY, { filter: queryFilter })
      .pipe(
        take(1),
        switchMap( (result) => {
          return of(Label.createLabels(result.data.getLabels));
        })
      );
  }

}
